// Funnel Builder Node Types
// Export all custom node components for React Flow

import CampaignNode from './CampaignNode';
import AdSetNode from './AdSetNode';
import AdNode from './AdNode';
import ABTestNode from './ABTestNode';
import SegmentNode from './SegmentNode';
import RetargetingPoolNode from './RetargetingPoolNode';

// Node types object for React Flow
export const nodeTypes = {
    campaign: CampaignNode,
    adset: AdSetNode,
    ad: AdNode,
    abtest: ABTestNode,
    segment: SegmentNode,
    retargetingPool: RetargetingPoolNode
};

// Individual exports
export { CampaignNode, AdSetNode, AdNode, ABTestNode, SegmentNode, RetargetingPoolNode };

// Node type definitions for creating new nodes
export const NODE_DEFAULTS = {
    campaign: {
        type: 'campaign',
        data: {
            name: 'New Campaign',
            objective: 'AWARENESS',
            platform: 'meta',
            budget: { amount: 0, type: 'daily' },
            funnelStage: 'TOFU',
            status: 'draft'
        }
    },
    adset: {
        type: 'adset',
        data: {
            name: 'New Ad Set',
            targeting: {
                ageMin: 18,
                ageMax: 65,
                genders: [],
                locations: [],
                interests: []
            },
            schedule: {},
            status: 'draft'
        }
    },
    ad: {
        type: 'ad',
        data: {
            name: 'New Ad',
            creativeId: null,
            creativeUrl: null,
            headline: '',
            primaryText: '',
            cta: 'LEARN_MORE',
            status: 'draft'
        }
    },
    abtest: {
        type: 'abtest',
        data: {
            name: 'A/B Test',
            trafficSplit: [50, 50],
            winnerCriteria: 'CTR',
            duration: 14,
            autoPauseLoser: true,
            variantIds: [],
            status: 'draft'
        }
    },
    segment: {
        type: 'segment',
        data: {
            name: 'New Segment',
            segmentType: 'custom',
            sourceStages: ['TOFU'],
            sourceCampaigns: [],
            intentSignals: {
                engagementDepth: { enabled: true, minAdViews: 2, minVideoWatchPercent: 50, clickThrough: false },
                websiteBehavior: { enabled: false, pagesVisited: [], minTimeOnSite: 30, cartActivity: false, formStarts: false },
                recencyFrequency: { enabled: true, lastInteractionDays: 14, minInteractions: 1 },
                stageProgression: { enabled: false, fromStage: 'TOFU', toStage: 'MOFU' }
            },
            estimatedSize: 0,
            funnelStage: 'MOFU',
            status: 'draft'
        }
    },
    retargetingPool: {
        type: 'retargetingPool',
        data: {
            name: 'New Retargeting Pool',
            poolType: 'engagement',
            sourceStage: 'TOFU',
            targetStage: 'MOFU',
            sourceCampaigns: [],
            trigger: {
                type: 'engagement',
                threshold: 1,
                lookbackDays: 30
            },
            estimatedSize: 0,
            isActive: true,
            status: 'draft'
        }
    }
};

// Node dimension hints for layout calculations
export const NODE_DIMENSIONS = {
    campaign: { width: 280, height: 180 },
    adset: { width: 240, height: 140 },
    ad: { width: 200, height: 260 },
    abtest: { width: 300, height: 220 },
    segment: { width: 220, height: 180 },
    retargetingPool: { width: 200, height: 150 }
};

// Funnel stage X positions
export const STAGE_POSITIONS = {
    TOFU: 100,
    MOFU: 500,
    BOFU: 900
};
